/* custom.js — Fade slideshow with working arrows/dots/autoplay + no flicker */
(() => {
  const FADE_SELECTOR = '.slideshow-section';          // change to target fewer slideshows if needed
  const AUTOPLAY_MS = 4500;                            // autoplay interval
  const TRANSITION_MS = 700;                           // keep in sync with your CSS fade duration

  function initFadeSlideshow(section) {
    // Enable fade mode (used by your CSS selectors)
    section.dataset.fade = 'true';

    const comp = section.querySelector('slideshow-component');
    const slides = Array.from(section.querySelectorAll('slideshow-slide'));
    if (!comp || slides.length < 2) {
      section.dataset.fadeReady = 'true';
      return;
    }

    // Controls
    const prevBtn = section.querySelector('.slideshow-control--previous');
    const nextBtn = section.querySelector('.slideshow-control--next');
    const dots = Array.from(section.querySelectorAll('.slideshow-controls__dots .slideshow-control'));

    // Determine initial active slide (fall back to 0)
    let index = slides.findIndex(s => s.getAttribute('aria-hidden') === 'false');
    if (index < 0) index = 0;

    // Prevent any accidental "double visible" state on load
    slides.forEach((s, idx) => s.setAttribute('aria-hidden', idx === index ? 'false' : 'true'));

    function setActive(i) {
      index = (i + slides.length) % slides.length;

      slides.forEach((s, idx) => {
        const active = idx === index;
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      dots.forEach((d, idx) => {
        d.setAttribute('aria-selected', idx === index ? 'true' : 'false');
      });
    }

    // Autoplay
    let timer = null;
    function startAutoplay() {
      stopAutoplay();
      // Only autoplay if not explicitly paused via attribute
      if (comp.hasAttribute('paused')) return;
      timer = setInterval(() => setActive(index + 1), AUTOPLAY_MS);
    }
    function stopAutoplay() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    // Wire controls (capture phase so we win against theme scroll handlers)
    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        setActive(index - 1);
        startAutoplay();
      }, true);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        setActive(index + 1);
        startAutoplay();
      }, true);
    }

    dots.forEach((dot, idx) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        setActive(idx);
        startAutoplay();
      }, true);
    });

    // Pause on hover/focus for nicer UX
    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    section.addEventListener('focusin', stopAutoplay);
    section.addEventListener('focusout', startAutoplay);

    // Mark ready AFTER initial state is correct (prevents flicker)
    setActive(index);
    section.dataset.fadeReady = 'true';

    // Start autoplay
    startAutoplay();

    // If Shopify re-renders sections (theme editor), re-init safely
    // (lightweight: just ensure ready remains true)
    setTimeout(() => { section.dataset.fadeReady = 'true'; }, TRANSITION_MS);
  }

  function boot() {
    document.querySelectorAll(FADE_SELECTOR).forEach(initFadeSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();























  (function () {
    function initSingleOpenAccordions(scope = document) {
      // Limit to your accordion wrapper(s)
      const accordions = scope.querySelectorAll('.accordion');

      accordions.forEach((accordion) => {
        const detailsList = accordion.querySelectorAll('accordion-custom details.details');

        detailsList.forEach((details) => {
          details.addEventListener('toggle', () => {
            // Only act when it was opened (toggle also fires when closing)
            if (!details.open) return;

            detailsList.forEach((other) => {
              if (other !== details) other.removeAttribute('open');
            });
          });
        });
      });
    }

    // Run now
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initSingleOpenAccordions());
    } else {
      initSingleOpenAccordions();
    }

    // Optional: if Shopify injects sections dynamically (theme editor), re-init safely
    document.addEventListener('shopify:section:load', (e) => {
      initSingleOpenAccordions(e.target);
    });
  })();